export default __webpack_public_path__ + "static/media/czechgo-screenshot-06.9e9c39e8.png";